var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0_964_117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_964_117",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_964_117",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_964_117",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEqUlEQVR4nO2dW6gVVRzGf2ZXSyu7vgTlJSmICoPSjAoiiGOSUFDRBSIl7bGyC0RFBRJdXowU6qkLJHEq8kGMKHuw0i5QGRV1IIljVnSge1ZOrFi7NsdzZs26zJrZzveD/9Nm/9ea+faatWd96wJCCCGEEEIIIVJyCbAGWA88CdwHXAfMSVqKcLI/8DxQlMQnwB3ATHc6EcuDDjH64ydgFXBgdKliQhYAf3kI0ov3gBMnTilCORT4PECMXnwPnBlcutiLxyPE6BfllL1TC18uBvYkEMTEZ8AM7xqI/zgS+DqRGL1Y93964ctzicUobGs73bsmggU1iNGLF3R/w7gc+LYGQf4GTgisU+c5DnipBlGu7fydjeR6YCyhIMtjKyT49zGzKZEgZ+iGpmEKsAL4OUKMDYnqIvow41OvB4hhHnvq0B3MBo7Gn/2AW4DfPAS5KqCcTnEAsA3YBSwNzGHGqLZWEGM4cd074XGsDzSXjHl1O/DHJGKMAkfVUP9OeByjwOLAnKcB70+Qcyhx3fc5ptnR17IxJzMQeFjgY/DePrHX1lD/fY41FTvhL4BFgWUsBDYGitopLvL0OHqtxbQqkZgjgB2BL3TbgbOkSFqejRzy+BNYrdkkaVgaKUZ/fKjxqDiOtS9/RcLYbf9NTU30g+kUGxKL0R9vAfOavsBB4sYaxeiFGf1d1vSFDgInAT9mEMTETU1fbNsxo7FvZBJjk/VKRAmrMokxJo/DzamePkUREfI4KnocOcQY1jMq7TqOIiLkcdS4jqMICHkckR5HkTDkcWRax1FUiBFguvqOtB5HETEv93yJUc7hER5H4Rlm6F04eCaTGNuBg6VGOZdlEmM3MF9i5Pc4ikniTonh5pVMYmyRCeVmWSYxfgFOVutoj8exQmKUI4+jZdyWqWWMyeNwI4+jRZjp/vI4WsQDmR5Vo1rH4Wa+fVPOIchQhh/XQCOPY0DXccTGiDwON/I4WuZxfJWpdaxu+mIHAXkcLUIeR4uQx9Ey5HG0bAfQItNajrlNX+wgsDaTICubvtBBYWMGMV7VOo7qvF2zGGPyOPz4tGZBrvasT+fZWaMYw52/uwHUteJpl32/ER4cVGPrGJISYRsW1yHGOokRxrwaxJDHEcHZicXQOo6WDZs85FH2HDtK8A6wGbgVOMSz/pfaPeLfBV4M6Lem2XX1m209nrDb1zbGFQnFeNP+SajCInui2vgc2zyWrU226vf+it+fYYUc/30zXfZcBnjy9K/AI/YQr6pzvUZK8j1ccV/FsjqZR7GLR0u+/2VTM+9jpoh+Z0/bPMazzIWOvGaZnIvHHDnMzXbhOlbpHAZkXxKzY+jNEZtTLnHkNy+qLp525DCfu/jdkcP0T9lZ7CHEVtvnxDbluRUOhXRxlyOHOYbVxQeOHI107uaI0o9KKrXHuomplyS/HDkYeXzJQS8/VByyuaatY3CzgI/HVcjspf6UnfleBzMnOHbC7Dx6t0eO84BvxuXY6bkB8z223P4cr9mj+xplqv0Pb46BuMEOqdTNFOBC+/6x0v4wfJlut2kyG/JfGbib9WzbJ5prv0BGmhBCCCGEEEIIIYSgg/wD55cfT5+RPvMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.092760630ef2eb6a2506add6b58c1856.svg";
export { ForwardRef as ReactComponent };